// Falls back to the English field when a Bulgarian translation hasn't been
// entered for a product yet, so a partially-translated catalog never shows blanks.
export function localizedName(product, language) {
  if (language === "bg" && product.nameBg) return product.nameBg;
  return product.name;
}

export function localizedDescription(product, language) {
  if (language === "bg" && product.descriptionBg) return product.descriptionBg;
  return product.description;
}
